<template>
    <div>
        <popup v-show="hasPopup"
               :popup-type="getPopupType"
               :popup-action="getPopupAction"
               :popup-message="getPopupMessage"
               @popup-action="_executePopupAction"
        />

        <PopupWithInput
            @submitAction="_executePopupWithInputAction"
        />

        <section>
            <a :data-title="$gettext('Přenačíst skupiny')" class="tab_button tab_button_refresh title_tooltip" @click.stop="_initChannelGroupsList" />

            <div class="status"><h2 v-translate>Skupiny stanic</h2>
                <a
                    v-if="isEditable"
                    @click.stop="_createNewChannelGroup"
                    :title="$gettext('Přidat skupinu stanic')"
                    class="add add_expand"
                    v-translate>Přidat skupinu stanic</a>
            </div>

            <div class="table_overflow">
              <table class="vypis vypis_detail parovaci_kody">
                <thead>
                <tr>
                  <th class="no_padding drag_drop"></th>
                  <th class="no_padding checkbox"></th>
                    <th><span class="name"><strong v-translate>Název</strong></span></th>
                    <th><span v-translate>Typ skupiny</span></th>
                    <th><span v-translate>Počet kanálů</span></th>
                    <th><span v-translate>Uživatelský profil</span></th>
                    <th><span v-translate>Tématická skupina</span></th>
                    <th><span v-translate>Přiřazená zařízení</span></th>
                    <th><span v-translate>Upraveno</span></th>
                    <th class="no_padding edit"/>
                </tr>
                </thead>
                <tbody>
                    <ChannelGroupRow
                        :devices="devices"
                        :isEditable="isEditable"
                        v-for="channelGroup in channelGroups"
                        :channel-group="channelGroup"
                        :key="channelGroup.id_group"
                        :selectedEntities="selectedEntities"
                        @input="select"
                        @resetChannelGroup="onResetChannelGroup"
                        @removeChannelGroup="onRemoveChannelGroup"
                        @duplicateChannelGroup="onDuplicateChannelGroup"
                        @showChannelGroupDetail="showSubscriberChannelGroupDetail"
                    />
                </tbody>
            </table>
            </div>
          <local-list-action-line
              :entities="devices"
              :selected-entities="selectedEntities"
              :multiple-action-options="multipleActionOptions"
              @select-all="toggleSelectAll"
              @run-multiple-action="executeMultipleAction"
          ></local-list-action-line>
        </section>
    </div>
</template>

<script>
import popup from "@/components/mixins/popup"
import popupWithInput from "@/components/mixins/popup-with-input"
import message from "@/components/mixins/message"
import Popup from "@/components/common/Popup"
import PopupWithInput from "../../../common/PopupWithInput";
import ChannelGroupRow from "../../devices/detail/ChannelGroupRow"
import localTable from "@/components/mixins/local-table"
import links from "../../../mixins/links";

export default {
    name: "SubscriberChannelGrups",
    components: {PopupWithInput, ChannelGroupRow, Popup},
    mixins: [popup, popupWithInput, message, localTable, links],
    props: {
      subscriber: Object,
      isEditable: Boolean,
    },
    created(ChannelGroupService) {
      this.channelGroupService = ChannelGroupService;
      this._initChannelGroupsList();
    },
    data() {
      return {
        channelGroups: [],
        devices: {},
        isLoaded: false,
      }
    },
  computed:{
    entities(){
      return Object.values(this.channelGroups);
    },
    csvHeaders(){
      return {
        'name': {name: this.$gettext('Název')},
        'type': {name: this.$gettext('Typ skupiny'), callback: (entity) => {
            if (entity.type === "tv") {
              return this.$gettext("Televize");
            } else if (entity.type === "radio") {
              return this.$gettext("Rádia");
            } else {
              return this.$gettext("Uživatelská skupina");
            }
          }},
        'channel_count': {name: this.$gettext('Počet kanálů'), callback: (entity) => {return entity.channels.length}},
        'subscriber_profile_name': {name: this.$gettext('Uživatelský profil')},
        'thematic_group_name': {name: this.$gettext('Tématická skupina')},
        'devices': {name: this.$gettext('Přiřazená zařízení'), callback: (entity) => {
            if(entity.device_ids.length === 0){
              return this.$gettext("Všechna zařízení");
            }else{
              let deviceNames = [];
              for(const idDevice of entity.device_ids){
                deviceNames.push(this.devices[idDevice]);
              }
              return deviceNames.join(', ');
            }
          }},
        'updated_timestamp': {name: this.$gettext('Upraveno'), callback: (entity) => {return entity.updated_timestamp ? this.$_datetime_format(entity.updated_timestamp) : ''}},
      }
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},
        {value: 'exportCsv', text: this.$gettext('Exportovat do CSV')},
        {value: 'delete-multi', text: this.$gettext('Smazat')}
      ];
    },
  },
    methods: {
        _initChannelGroupsList() {
            this.isLoaded = false;
            this.channelGroups = [];
            this.setLoadingMessage();

            return this.channelGroupService.getEntitiesBySubscriberId(this.subscriber.id)
                .then((response) => {
                    this.emptyMessage();
                    this.channelGroups = response.channel_groups;
                    this.devices = response.devices;
                });
        },
        _createNewChannelGroup() {
            this.$router.push({
                name: 'createSubscriberChannelGroup',
                params: {
                    idSubscriber: this.subscriber.id
                }
            });
        },
        onDuplicateChannelGroup(channelGroup) {
            let duplicatedName = channelGroup.name + ' (' + this.$gettext('kopie') + ')';

            this.showPopupWithInput("duplicate-channel-group", this.$gettext("Zadejte název nové duplikované skupiny:"), this.$gettext("Duplikovat"), duplicatedName, channelGroup);
        },
        onResetChannelGroup(id, showPopup = true) {
            if (showPopup) {
                this.showPopup(id, 'reset', 'reset-channel-group', null, this.$gettext('Opravdu si přejete resetovat skupinu kanálů?'));
            } else {
                this._removeChannelGroup(id);
            }
        },
        onRemoveChannelGroup(id, showPopup = true) {
            if (showPopup) {
                this.showPopup(id, 'delete', 'delete-channel-group');
            } else {
                this._removeChannelGroup(id);
            }
        },
        _removeChannelGroup(id) {
            this.setLoadingMessage();
            this.channelGroupService.deleteEntity(id, {id_selected_operator: this.$_loggedUser_selectedOperatorId})
                .then(() => {
                    this.setSuccessMessage();
                    return this._initChannelGroupsList();
                }).catch((error) => {
              this.$emit('reload-entity');
                this.setErrorMessage(this._processDetailErrorMessage(error));
            });
        },
        _executePopupAction(value) {
            if (value) {
                switch(this.getPopupAction) {
                    case 'reset-channel-group':
                        this.onResetChannelGroup(this.getPopupId, false);
                        break;
                    case 'delete-channel-group':
                        this.onRemoveChannelGroup(this.getPopupId, false);
                        break;
                    case 'delete':
                      this.$emit('delete-subscriber');
                      break;
                }
            }
            this.hidePopup();
        },
        _executePopupWithInputAction(action, inputValue, data) {
            if (action === 'duplicate-channel-group') {
                this._createDuplicatedChannelGroup(data, inputValue);
            }
        },
        _createDuplicatedChannelGroup(channelGroup, newChannelGroupName) {
            let newChannelGroup = {
                id_subscriber: this.subscriber.id,
                name: newChannelGroupName,
                device_ids: [...channelGroup.device_ids],
                channel_ids: channelGroup.channels.map((channel) => channel.id)
            }

            this.createChannelGroup(newChannelGroup);
        },
        createChannelGroup(newChannelGroup) {
            this.setLoadingMessage();
            this.channelGroupService.createEntity(newChannelGroup).then(() => {
                this.setSuccessMessage();
                this._initChannelGroupsList();
            }).catch((error) => {
                this.setErrorMessage(this._processDetailErrorMessage(error));
            });
        },
      executeMultipleAction(action, activeKey) {
        let actionIds = this.selectedEntities.join();
        switch (action) {
          case 'delete-multi':
            this.onRemoveChannelGroup(actionIds);
            break;
          default:
            this.runMultipleAction(action, activeKey);
        }
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscribers/channelGroups/ChannelGroups.vue